import styled from 'styled-components';

const Main = styled.main`
  display: flex;
  flex-direction: column;
  gap: 2rem;

  transition: 0.3s;
  flex-shrink: 0;

  position: relative;
  align-self: center;

  width: 100%;
  max-width: ${props => props.theme.layout.breakpoints.lg};

  @media (max-width: ${props => props.theme.layout.breakpoints.md}) {
    gap: 1.5rem;
  }
`;

export default Main;
